import { globe } from "react-icons-kit/fa/globe";
import { fileText } from "react-icons-kit/icomoon/fileText";
import { ic_view_list } from "react-icons-kit/md/ic_view_list";
import { languageService } from "../../Language/language.service";
import { versionInfo } from "../MainPage/VersionInfo";

export const LIST_VIEW_SELECTION_TYPES = {
  GIS: "GIS",
  AssetsView: "AssetsView",
  Card: "CardView",
};

export const LIST_VIEW_SELECTION = [
  {
    title: LIST_VIEW_SELECTION_TYPES.GIS,
    icon: globe,
    tooltip: {
      show: false,
      text: "GIS",
    },
  },
  {
    title: LIST_VIEW_SELECTION_TYPES.AssetsView,
    icon: ic_view_list,
    tooltip: {
      show: false,
      text: `${languageService("Assets List View")}`,
    },
  },
  {
    title: LIST_VIEW_SELECTION_TYPES.Card,
    icon: fileText,
    tooltip: {
      show: false,
      text: `${languageService("Card List View")}`,
    },
  },
];

export const LIST_VIEW_SELECTION_GET = () => {
  if (!versionInfo.isReVAMP()) return LIST_VIEW_SELECTION.filter((l) => l.title !== LIST_VIEW_SELECTION_TYPES.Card);
  if (versionInfo.isReVAMP()) return LIST_VIEW_SELECTION.filter((l) => l.title !== LIST_VIEW_SELECTION_TYPES.GIS);
  return LIST_VIEW_SELECTION;
};



// WEBPACK FOOTER //
// ./src/components/LampAssets/ViewSelection.js